import stylesheet from './TagGroup.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";
import DragScroll from "../../base/util/DragScroll";

class NXTTagGroup extends CustomComponent {

    dragScroll: DragScroll;

    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    render() {
        const scrollContainer = document.createElement('div');
        scrollContainer.classList.add('scroll-container')
        const tagContainer = document.createElement('div');
        tagContainer.innerHTML = `<slot></slot>`;
        tagContainer.classList.add('items')
        scrollContainer.appendChild(tagContainer);
        this.dragScroll = new DragScroll(tagContainer);
        return scrollContainer;
    }

    disconnectedCallback() {
        this.dragScroll?.beforeDestroy();
    }

    connectedCallback() {
        super.connectedCallback();
        this.dragScroll?.mounted();
    }

}

customElements.define('nxt-tag-group', NXTTagGroup);
